import styled, { css, AnyStyledComponent } from 'styled-components'

import { desktopBreakpoint, mobileBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'
import { zIndexScale } from '../../../../utils/style-utils'
import FullStar from '../../../../assets/icons/star.svg'
import { SuitableStates } from '../../../../models/property-details-page/suitables-model'
import Offer from '../../../../assets/icons/offer-badge.svg'
import ExternalLink from '../../../common/external-link'

export const GridCardContainer = styled.div(
    ({ theme }) => css`
        cursor: pointer;
        background: ${theme.colors.white};
    `,
)

export const ImageContainer = styled.div(
    ({ theme }) => css`
        position: relative;
        width: 12.5rem;
        height: 9.375rem;
        overflow: hidden;
        border-radius: 1rem;

        img {
            width: 100%;
            height: 100%;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            width: 17.625rem;
            height: 11.688rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 14.453rem;
            height: 9.584rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            width: 17.625rem;
            height: 11.688rem;
        }
    `,
)

export const CardContent = styled.div(
    ({ theme }) => css`
        padding: 0.75rem 0 0;
    `,
)

export const LocationRatingContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
)

export const LocationText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.75rem;
        color: #6f6f6f;
        font-weight: 400;
    `,
)

export const LocationContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: 0.25rem;
    `,
)

export const RatingContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        margin-right: 2rem;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-right: 1rem;
        }

        @media only screen and {
            margin-right: 2.5rem;
        }
    `,
)

export const FullStarIcon = styled(FullStar as AnyStyledComponent)`
    margin-right: 0.25rem;
`

export const RatingText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1rem;
        color: #282828;
    `,
)

export const PropertyTitle = styled.h3(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.5rem;
        color: #282828;
        margin: 2px 0 0 0;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 12.5rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 14.453rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            width: 17.625rem;
        }
    `,
)

export const SeoHref = styled(ExternalLink)`
    font: inherit;
    text-decoration: none;
`

export const PropertyDescription = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.75rem;
        color: #6f6f6f;
        margin: 0.25rem 0 0;
        line-height: 1rem;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
)

export const PriceContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.375rem;
        margin-top: 0.25rem;
    `,
)

export const PersonDetails = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1rem;
        color: #6f6f6f;
        margin: 0.25rem 0 0;
    `,
)

export const ObjectTopRecommendationPill = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        position: absolute;
        top: 0.75rem;
        left: 0.5rem;
        width: 5rem;
        border-radius: 1rem;
        border: 1px solid #f3f0f3;
        color: ${props => props.theme.colors.tfwPurple};
        background-color: #f3f0f3;
        font-size: 0.75rem;
        padding: 0.25rem 0.5rem;
        z-index: ${zIndexScale.smallTags.xsmall};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 0.875rem;
            width: 5.625rem;
        }
    `,
)

export const FavoriteButton = styled.div(
    ({ theme }) => css`
        position: absolute;
        top: ${theme.spacing.small};
        right: ${theme.spacing.small};
        z-index: ${zIndexScale.smallTags.xsmall};
    `,
)

export const OfferBadge = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: linear-gradient(90deg, #d2faea 0%, #ffffff 100%);

        padding: 0.25rem 0.5rem;
        z-index: ${zIndexScale.smallTags.xsmall};
    `,
)

export const OfferIcon = styled(Offer as AnyStyledComponent)`
    width: 1rem;
    height: 1rem;
    margin-right: 0.25rem;
`

export const OfferText = styled.span`
    color: #0d7c4f;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 0.875rem;
        line-height: 1.375rem;
    }
`
